import React from 'react'
import { graphql } from 'gatsby'
import { default as NavWidgetComponent } from '@berlitz/nav-widget'
import { StyledNavLink } from './style'

const SubmitButton = ({ label, firstOption, secondOption }) => {
  const linkUrl = secondOption || firstOption
  return <StyledNavLink to={linkUrl}>{label}</StyledNavLink>
}

const NavWidget = ({ data = [] }) => {
  const navigationWidgetOptions = data.map(node => {
    return {
      sortOrder: node.node.data?.sort_order,
      identifierText: node.node.data?.identifierText || '',
      audience: {
        label: node.node.data?.audienceOption?.[0]?.label || '',
        value: node.node.data?.audienceOption?.[0]?.value || '',
      },
      intentText: node.node.data?.intentText || '',
      firstOption: (node.node?.data?.body || [])
        .filter(
          key => key.__typename === 'PrismicCourseWizardDataBodyOptionSetOne'
        )[0]
        .items.map(option => ({
          label: option?.label || '',
          value: option?.page?.url || '',
        })),
      secondOption: null,
    }
  })
  const sortedNavigationWidgetOptions = navigationWidgetOptions.sort(
    (a, b) => a.sortOrder - b.sortOrder
  )

  return (
    <NavWidgetComponent
      data={sortedNavigationWidgetOptions}
      defaultOption={sortedNavigationWidgetOptions[0]}
    >
      <SubmitButton
        // TODO - Think of a more elegent way to get this label and store it in CS
        label={data[0]?.node?.data?.submitButtonLabel || 'Go'}
      />
    </NavWidgetComponent>
  )
}

export const query = graphql`
  fragment CourseWizard on PrismicCourseWizardDataBodySlicesType {
    ... on PrismicCourseWizardDataBodyOptionSetOne {
      __typename
      items {
        label
        page {
          url
        }
      }
    }
    ... on PrismicCourseWizardDataBodyOptionSetTwo {
      __typename
      items {
        label
        page {
          url
        }
      }
    }
  }
`

export default NavWidget
